module.exports = "<svg-inline id=\"drill-down-menu\" src=\"/images/common/threedots-round.svg\"></svg-inline>\n"